"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nativeCsvRowAction = exports.NativeCsvRowActionResultSchema = exports.selectColumnsResultSchema = exports.standardCsvRowResultSchema = exports.nativeCsvRowActionArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
var nativeCsvReader_1 = require("./nativeCsvReader");
// Argument schema
exports.nativeCsvRowActionArgsSchema = zod_1.z.object({
    row: nativeCsvReader_1.CsvDataRowSchema.describe('The CSV row to process.'),
    function: zod_1.z.discriminatedUnion('operation', [
        zod_1.z.object({
            operation: zod_1.z.literal('add_columns'),
            columnNames: zod_1.z.array(zod_1.z.string()).describe('The names of the columns to add.'),
            columnValues: zod_1.z.array(zod_1.z.string()).describe('The values of the columns to add.'),
        }),
        zod_1.z.object({
            operation: zod_1.z.literal('remove_columns'),
            columnNames: zod_1.z.array(zod_1.z.string()).describe('The names of the columns to remove.'),
        }),
        zod_1.z.object({
            operation: zod_1.z.literal('select_columns'),
            columnNames: zod_1.z.array(zod_1.z.string()).describe('The names of the columns to select.'),
        }),
        zod_1.z.object({
            operation: zod_1.z.literal('update_columns'),
            columnNames: zod_1.z.array(zod_1.z.string()).describe('The names of the columns to update.'),
            columnValues: zod_1.z.array(zod_1.z.string()).describe('The values of the columns to update.'),
        }),
        zod_1.z.object({
            operation: zod_1.z.literal('filter_rows'),
            rows: zod_1.z.array(zod_1.z.number()).describe('The rows to filter.'),
        }),
    ]),
    emitMode: common_1.emitModeSchema.default('multi').describe('The mode to emit the results in.'),
});
// Result schemas for different operations
exports.standardCsvRowResultSchema = nativeCsvReader_1.CsvDataRowSchema.describe('The processed CSV row.');
exports.selectColumnsResultSchema = zod_1.z.object({
    value: zod_1.z.string().describe('Selected column value.'),
});
exports.NativeCsvRowActionResultSchema = zod_1.z.union([
    exports.standardCsvRowResultSchema,
    exports.selectColumnsResultSchema,
]);
// Tool definition with emit-mode aware dynamic result schema
exports.nativeCsvRowAction = (0, common_1.createEmitModeToolMetadata)({
    id: 'nativeCsvRowAction',
    displayName: 'CSV Row Action',
    displayDescription: 'Perform actions on a single CSV row',
    category: 'native',
    color: common_1.BRAND_COLORS.NATIVE,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.NATIVE),
    icon: 'csv',
    argsSchema: exports.nativeCsvRowActionArgsSchema,
}, {
    dependencies: ['function.operation'],
    variants: [
        {
            when: { 'function.operation': 'select_columns' },
            schema: exports.selectColumnsResultSchema,
            description: 'Returns selected column value for select_columns operation',
        },
        {
            when: { 'function.operation': 'add_columns' },
            schema: exports.standardCsvRowResultSchema,
            description: 'Returns processed CSV row for add_columns operation',
        },
        {
            when: { 'function.operation': 'remove_columns' },
            schema: exports.standardCsvRowResultSchema,
            description: 'Returns processed CSV row for remove_columns operation',
        },
        {
            when: { 'function.operation': 'filter_rows' },
            schema: exports.standardCsvRowResultSchema,
            description: 'Returns processed CSV row for filter_rows operation',
        },
        {
            when: { 'function.operation': 'update_columns' },
            schema: exports.standardCsvRowResultSchema,
            description: 'Returns processed CSV row for update_columns operation',
        },
    ],
    defaultSchema: exports.standardCsvRowResultSchema,
});
